import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const getAllAds = createAsyncThunk(
  "api/ads/getAllAds",
  async ({ page = 1, limit = 8, searchQuery = "" }) => {
    const response = await axiosInstance.get("/ads/getAllAds", {
      params: {
        page,
        limit,
        value: searchQuery,
      },
    });
    return response.data;
  }
);

export const getAdById = createAsyncThunk("ads/getAdById", async (id) => {
  const response = await axiosInstance.get(`/ads/getAdById/${id}`);
  return response.data;
});

export const createAd = createAsyncThunk("ads/createAd", async (formData) => {
  const response = await axiosInstance.post("/ads/createAdd", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
});

export const updateAd = createAsyncThunk(
  "ads/updateAd",
  async ({ id, title, description, image, status, category_id }) => {
    const response = await axiosInstance.put(`/ads/updateAd/${id}`, {
      title,
      description,
      image,
      status,
      category_id,
    });

    return response.data;
  }
);

export const deleteAd = createAsyncThunk("apiAds/deleteAd", async (id) => {
  await axiosInstance.delete(`/ads/deleteAd/${id}`);
  return { id };
});

const apiAdsSlice = createSlice({
  name: "apiAds",
  initialState: {
    data: [],
    dataId: [],
    loading: false,
    error: null,
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
  },
  reducers: {
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllAds.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllAds.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.totalPages = action.payload.totalPages;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(getAllAds.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getAdById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAdById.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload;
      })
      .addCase(getAdById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createAd.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createAd.fulfilled, (state, action) => {
        state.loading = false;

        if (Array.isArray(state.data?.data)) {
          state.data.data.unshift(action.payload);
          state.data.totalCount += 1;
        }
      })
      .addCase(createAd.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateAd.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateAd.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.data?.data?.findIndex(
          (ad) => ad.id === action.payload.id
        );
        if (index !== -1) {
          state.data.data[index] = action.payload;
        }
      })
      .addCase(updateAd.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteAd.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAd.fulfilled, (state, action) => {
        state.loading = false;
        console.log("DELETE action.payload:", action.payload);
        console.log("Before delete, state.data:", state.data);
        if (Array.isArray(state.data)) {
          state.data = state.data.filter((ad) => ad.id !== action.payload.id);
        } else {
          console.warn("state.data is not an array!", state.data);
          state.data = [];
        }
      })
      .addCase(deleteAd.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { setPage } = apiAdsSlice.actions;
export default apiAdsSlice.reducer;
